import LeaveTypeComponent from "../components/LeaveType";
import useLeaveType from "../hooks/useLeaveType";

function LeaveType(props) {
  const useLeaveTypeProps = useLeaveType(props);
  return <LeaveTypeComponent {...useLeaveTypeProps} />;
}

export default LeaveType;
